import React from 'react';
import DevolucionesBase from './DevolucionesBase.jsx';

export default function DevolucionesInversaPage() {
  return <DevolucionesBase kind="inversa" />;
}
